const Crypto = require("crypto-js");

exports.btoa = function (rawString) {
  return Buffer.from(rawString).toString("base64");
};

exports.atob = function (encodedString) {
  return Buffer.from(encodedString, "base64").toString();
};

exports.generateIdSync = function (count) {
  var _sym = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"; //abcdefghijklmnopqrstuvwxyz1234567890
  var str = "";

  for (var i = 0; i < count; i++) {
    str += _sym[parseInt(Math.random() * _sym.length)];
  }

  return str;
};

exports.encrypt = (value = '') => Crypto.AES.encrypt(value, 'qrcode-redcode').toString()

exports.decrypt = (value = '') => Crypto.AES.decrypt(value, 'qrcode-redcode').toString(Crypto.enc.Utf8)
